export enum OnboardingAccountType {
    CONSOLIDATED = 'CONSOLIDATED',
    LINKED = 'LINKED',
    LINKED_1 = 'LINKED_1',
    LINKED_2 = 'LINKED_2',
    INDEPENDENT = 'INDEPENDENT'
}
